import {
  ShieldCheck, Server, Gauge, Network, Siren, Search, Bug, DatabaseBackup, Mail,
  Radar, FileSearch, ShieldAlert, Code2, BrainCircuit, ClipboardCheck, Webhook, Boxes,
} from "lucide-react";

const map = {
  ShieldCheck, Server, Gauge, Network, Siren, Search, Bug, DatabaseBackup, Mail,
  Radar, FileSearch, ShieldAlert, Code2, BrainCircuit, ClipboardCheck, Webhook, Boxes,
};

export default function Icon({ name, className = "" }) {
  const Cmp = map[name] || ShieldCheck;
  return <Cmp className={className} />;
}
